export default function Marquee() {
  const words = ["Organize", "Automate", "Grow", "Remember", "Follow up"];
  return (
    <section className="relative py-14 md:py-20 overflow-hidden border-y border-black/5" data-testid="editorial-marquee">
      <div className="marquee-track">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-16 shrink-0">
            {words.map((w, j) => (
              <span
                key={`${i}-${j}`}
                className="font-display text-[14vw] md:text-[9vw] leading-none tracking-tighter font-medium"
                style={{
                  color: "transparent",
                  WebkitTextStroke: "1px rgba(10,10,31,0.28)",
                }}
              >
                {w}
                {j % 2 === 1 ? (
                  <span
                    className="ml-6"
                    style={{
                      fontFamily: "var(--font-serif)",
                      fontStyle: "italic",
                      color: "var(--accent)",
                      WebkitTextStroke: "0",
                    }}
                  >
                    ·
                  </span>
                ) : (
                  <span className="mx-6" style={{ color: "rgba(10,10,31,0.15)" }}>—</span>
                )}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
